<template>
    <b-nav class="flex-row-reverse main-nav"
           lg="6"
           style="position: absolute; top: 0; width: 100%; background-color: RGBA(0, 0, 0, .35)"
    >
        <b-nav-item to="/contact">Kontakt</b-nav-item>
        <b-nav-item to="/details">Details & Preis</b-nav-item>
        <b-nav-item to="/gallery">Ferienhaus</b-nav-item>
        <b-nav-item to="/" exact>Startseite</b-nav-item>
    </b-nav>
</template>

<script>
export default {
  name: 'Navigation'
}
</script>

<style>
    .Masthead .nav-item a {
        color: #fff;

        font-family: 'Alegreya SC', serif;
        font-size: 1.25rem;
    }

    .Masthead .nav-item a.active,
    .Masthead .nav-item a:hover {
        text-decoration: underline;
    }

</style>
